export const FILTER_ENDOFDAY_REPORT = 'FILTER_ENDOFDAY_REPORT'
export const ENDOFDAY_REPORT_RES = 'ENDOFDAY_REPORT_RES'
export const REQUEST_CANCEL = 'REQUEST_CANCEL'
export const FILTER_APPOINTMENTLIST_REPORT = 'FILTER_APPOINTMENTLIST_REPORT'
export const FILTER_APPOINTMENTLIST_REPORT_RES =
  'FILTER_APPOINTMENTLIST_REPORT_RES'
export const FILTER_COLLECTION_REPORT = 'FILTER_COLLECTION_REPORT'
export const FILTER_COLLECTION_REPORT_RES = 'FILTER_COLLECTION_REPORT_RES'
export const ALL_USERS = 'ALL_USERS'
export const ALL_USERS_RES = 'ALL_USERS_RES'
export const PRIOR_REPORT = 'PRIOR_REPORT'
export const PRIOR_REPORT_RES = 'PRIOR_REPORT_RES'
export const FILTER_SELF_REPORT = 'FILTER_SELF_REPORT'
export const SELF_PAY_PATIENT_REPORT_REQUEST = 'SELF_PAY_PATIENT_REPORT_REQUEST'
export const SELF_PAY_PATIENT_REPORT_SUCCESS = 'SELF_PAY_PATIENT_REPORT_SUCCESS'
export const SELF_PAY_PATIENT_EXPORT_REQUEST = 'SELF_PAY_PATIENT_EXPORT_REQUEST'
export const SELF_PAY_PATIENT_EXPORT_SUCCESS = 'SELF_PAY_PATIENT_EXPORT_SUCCESS'
export const CLEAR_SELF_PAY_EXPORT = 'CLEAR_SELF_PAY_EXPORT'
export const SELF_PAY_PATIENT_REQUEST_CLAIM = 'SELF_PAY_PATIENT_REQUEST_CLAIM'
export const SELF_PAY_PATIENT_SUCCESS_CLAIM = 'SELF_PAY_PATIENT_SUCCESS_CLAIM'
export const SELF_PAY_PATIENT_REQUEST_CPT = 'SELF_PAY_PATIENT_REQUEST_CPT'
export const SELF_PAY_PATIENT_SUCCESS_CPT = 'SELF_PAY_PATIENT_SUCCESS_CPT'
export const CLEAR_SELF_PAY_CLAIM = 'CLEAR_SELF_PAY_CLAIM'
export const CLEAR_SELF_PAY_CPT = 'CLEAR_SELF_PAY_CPT'
export const PREVISIT_ESTIMATE_REPORT_REQUEST = 'PREVISIT_ESTIMATE_REPORT_REQUEST'
export const PREVISIT_ESTIMATE_REPORT_SUCCESS = 'PREVISIT_ESTIMATE_REPORT_SUCCESS'
export const PREVISIT_ESTIMATE_EXPORT_REQUEST = 'PREVISIT_ESTIMATE_EXPORT_REQUEST'
export const PREVISIT_ESTIMATE_EXPORT_SUCCESS = 'PREVISIT_ESTIMATE_EXPORT_SUCCESS'
export const CLEAR_PREVISIT_ESTIMATE_EXPORT = 'CLEAR_PREVISIT_ESTIMATE_EXPORT'
export const PREVISIT_ESTIMATE_DOWNLOAD_REQUEST = 'PREVISIT_ESTIMATE_DOWNLOAD_REQUEST'
export const PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS = 'PREVISIT_ESTIMATE_DOWNLOAD_SUCCESS'
export const CLEAR_PREVISIT_ESTIMATE_DOWNLOAD = 'CLEAR_PREVISIT_ESTIMATE_DOWNLOAD'